import {
  MEDIA_IMAGE_CONTENT_TYPES,
  MEDIA_VIDEO_CONTENT_TYPES,
  buildAcceptAttribute,
} from '@/constants/media';

export const CHAT_LIST_REFETCH_INTERVAL_MILLISECONDS = 20000;
export const CHAT_ACTIVE_CONVERSATION_REFETCH_INTERVAL_MILLISECONDS = 5000;
export const CHAT_UNREAD_BADGE_MAXIMUM = 99;
export const CHAT_MESSAGE_PAGE_SIZE = 30;

const CHAT_MEDIA_DOCUMENT_CONTENT_TYPES = [
  'image/gif',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
] as const;

export const CHAT_MEDIA_ALLOWED_CONTENT_TYPES = [
  ...MEDIA_IMAGE_CONTENT_TYPES,
  ...MEDIA_VIDEO_CONTENT_TYPES,
  ...CHAT_MEDIA_DOCUMENT_CONTENT_TYPES,
];

export const CHAT_MEDIA_ALLOWED_CONTENT_TYPES_FOR_CLIENT = [
  ...MEDIA_IMAGE_CONTENT_TYPES,
  ...CHAT_MEDIA_DOCUMENT_CONTENT_TYPES,
];

export const CHAT_MEDIA_ACCEPT_ATTRIBUTE = buildAcceptAttribute(CHAT_MEDIA_ALLOWED_CONTENT_TYPES);
export const CHAT_MEDIA_ACCEPT_ATTRIBUTE_FOR_CLIENT = buildAcceptAttribute(
  CHAT_MEDIA_ALLOWED_CONTENT_TYPES_FOR_CLIENT
);
